import React, {useEffect, useState} from 'react';
import '../../Styles/Taetigkeitsbericht/verortung.css';

import TagesTatigImageSliderComponent from "./TatigTagesImageSliderComponent";

function TagesTatigVerortung(props) {
    const [verortungImages, setVerortungImages] = useState([]);
    useEffect(() => {
        setVerortungImages(props.verortungImages);
    }, [props.verortungImages]);


    return (<>
        {/*<div className="verortung-area add-right-10-padding">*/}
        <div className="verortung-area" style={{paddingLeft:20,paddingRight:0}}>
            {verortungImages?.length === 0 &&
            <label className="handwai-text-label-normal">{"Keine Bilder vorhanden"}</label>}
            {verortungImages?.length > 0 &&
            <TagesTatigImageSliderComponent
                images={props.verortungImages}
                width={500}
                height={400}
            />
            }
        </div>
    </>);
}

export default TagesTatigVerortung;
